import { type ReactNode } from 'react'
import { Avatar, Stack, Text } from '@mantine/core'
import { ColorPrimitives, SizePrimitives, Theme, useTranslation } from '@front/model'
import { MaterialSymbolIcon } from '@components'
import { PreviewTrustList } from './PreviewTrustList'
import { PreviewSocialLinks } from './PreviewSocialLinks'
import { type CardPreviewProps, toBannerGradient } from './previewContent'
import { PreviewActionTiles } from './PreviewActionTiles'
import classes from './CardPreview.module.css'

const HERO_AVATAR_SIZE = 128

export const PreviewMobileHero = ({ content, tokens }: CardPreviewProps): ReactNode => {
  const { t } = useTranslation()

  return (
    <Stack
      bg={tokens.banner}
      c={tokens.onBanner}
      className={classes.mobileHero}
      gap='lg'
      pb='lg'
      pt='xl'
      px='lg'
      style={{ backgroundImage: toBannerGradient(tokens) }}
    >
      <Stack align='center' gap='md'>
        <Avatar
          bd={`4px solid ${ColorPrimitives.white['500']}`}
          bg={Theme.light.background.neutral.tertiary}
          c={Theme.light.icon.neutral.tertiary}
          radius='full'
          size={HERO_AVATAR_SIZE}
          src={content.repAvatarUrl}
        >
          <MaterialSymbolIcon icon='person' size={SizePrimitives['16']} />
        </Avatar>
        <Stack align='center' gap={0} ta='center'>
          <Text fw='bold' size='2xl'>
            {t('Rep Name')}
          </Text>
          <Text c={tokens.accentOnBanner} fw={600}>
            {t('Sales Representative')}
          </Text>
          <Text c={tokens.onBannerMuted}>{content.companyName}</Text>
        </Stack>
      </Stack>
      {content.showTrust && (
        <Stack align='center'>
          <PreviewTrustList
            companyName={content.companyName}
            iconColor={tokens.accentIconOnBanner}
            showRating={content.hasGoogleBusinessProfile}
            rating={content.rating}
            textColor={tokens.onBanner}
          />
        </Stack>
      )}
      <PreviewActionTiles tokens={tokens} />
      {content.showSocials && (
        <PreviewSocialLinks background={ColorPrimitives.white['1000']} color={tokens.ink} links={content.socials} />
      )}
    </Stack>
  )
}
